<template>
	<v-container>
		<div v-if="feedback == 0">
			<v-row class="contentRow">
				<v-col cols="12" align="center">
					<v-btn outlined class="ma-2 white--text" color="primary" @click="commentBoxOpen = true" v-if="!isFeedbackGiven">Give your feedback</v-btn>
					<!--<v-btn dark color="orangeButton" class="ma-2" @click="getFreeAcc()">GET A FREE TRAIL</v-btn>-->
				</v-col>
			</v-row>
			<v-row class="contentRow">
				<v-col>
					<v-avatar
						class="float-left d-none d-md-block"
						style="position:absolute;"
						color="grey"
						size="85"
					>
						<v-img v-if="logo" width="300" :src="logo" />
						<v-icon v-else size="43">fas fa-building</v-icon>
					</v-avatar>
					<h1>
						<span
							class="error--text"
							v-if="
								audit &&
									audit.expiryDate &&
									$moment(audit.expiryDate).isBefore($moment())
							"
							>(Expired) </span
						>Onsite-Audit {{ templateName }}
					</h1>
					<span class="text-center"
						><p>Audit from {{ recipientName }}</p></span
					>
				</v-col>
			</v-row>
			<v-row class="contentRow grey" v-if="replacing">
				<v-col>
					<v-icon dark left class="mb-2">fas fa-info-circle</v-icon>
					<p class="white--text text-h5">
						This audit replaced another audit. <br />
						The edited fields are highlighted below.
					</p>
					<v-btn
						small
						light
						:to="{ name: `Audit Details`, params: { id: replacing } }"
						target="_blank"
						>View it here.</v-btn
					>
				</v-col>
			</v-row>
			<v-row class="contentRow warning" v-if="replacedBy">
				<v-col>
					<h2 class="white--text">
						<v-icon dark left>fas fa-exclamation-triangle</v-icon>This audit was
						replaced by another audit. <br />
						<p><i>See what was edited below</i></p>
						<v-btn
							light
							:to="{ name: `Audit Details`, params: { id: replacedBy } }"
							target="_blank"
							>View it here.</v-btn
						>
					</h2>
				</v-col>
			</v-row>
			<div v-for="(question, index) in auditData" :key="index">
				<v-row v-if="index == 0"></v-row>
				<v-row
					class="my-13"
					v-else-if="shouldDisplay(question) && question.type == 'spacer'"
				></v-row>
				<v-row
					v-else-if="shouldDisplay(question) && question.type == 'title'"
					class="contentRow primary"
				>
					<v-col cols="6" class="mr-auto white--text">
						<h2>{{ question.name }}</h2>
					</v-col>
				</v-row>
				<v-row
					no-gutters
					v-else-if="shouldDisplay(question) && question.type == 'attachment'"
					class="contentRow secondary"
					dark
				>
					<v-col cols="6" class="mr-auto white--text">
						<h2>
							<v-icon dark left>fas fa-paperclip</v-icon>{{ question.name }}
						</h2>
					</v-col>
					<!--'File uplad' text field-->
					<v-col cols="12" class="white--text">
						<file-uploader
							:value="question.fileID"
							:readonly="true"
							:disabled="true"
							:dark="true"
							:name="question.name"
						/>
					</v-col>
				</v-row>
				<v-row class="contentRow" v-else-if="shouldDisplay(question)">
					<v-col>
						<h4 class="primary--text">
							{{ question.name
							}}<sup
								><v-icon v-if="question.Required" color="error" right x-small
									>fa-asterisk</v-icon
								></sup
							>
							<v-chip
								v-if="question.previousAnswer"
								class="ml-2"
								label
								small
								color="warning"
							>
								Edited
							</v-chip>
						</h4>
						<br />
						<p v-if="question.type == 'file'">
							<file-uploader
								:value="question.answer"
								:readonly="true"
								:disabled="true"
								:dark="true"
								:name="question.name"
							/>
							<v-alert
								v-if="question.previousAnswer"
								icon="fas fa-history"
								border="left"
								color="blue-grey"
								light
								dense
								outlined
								text
							>
								<b>Previous Answer:</b><br />
								<file-uploader
									:value="question.previousAnswer"
									:readonly="true"
									:disabled="true"
									:dark="true"
									:name="question.name"
								/>
							</v-alert>
						</p>
						<p v-else-if="!question.answer">
							<i>This question was not answered</i>
						</p>
						<p v-else>{{ question.answer }}</p>
						<v-alert
							v-if="question.previousAnswer && question.type != 'file'"
							icon="fas fa-history"
							border="left"
							color="blue-grey"
							dark
							dense
							outlined
							text
						>
							<b>Previous Answer:</b><br />{{ question.previousAnswer }}</v-alert
						>
					</v-col>
				</v-row>
			</div>
			<!-- <v-row
				class="contentRow darkColor--text"
				v-if="
					audit &&
						audit.isSender == true &&
						audit.allowFlowDown == true &&
						$accessToOperation('AFD', 'R')
				"
			>
				<v-col>
					<h2>
						Audit Flow Down<v-icon right>fas fa-clone</v-icon
						><v-icon right>fas fa-turn-down</v-icon>
					</h2>
					<p>
						Duplicate this audit to send to your suppliers. Clicking the button
						below will create a new Audit Template based on this Audit. The
						Auditor will be able to see how many people you have forwarded this
						audit to.
					</p>
					<v-btn @click="flowDown"
						>Flow Down <v-icon right>fas fa-up-right-from-square</v-icon></v-btn
					>
				</v-col>
			</v-row> -->
			<!--Flow down view for auditor-->
			<v-row
				class="contentRow darkColor--text"
				v-if="
					audit &&
						audit.allowFlowDown == true &&
						typeof audit.retransmissions != 'undefined' &&
						$accessToRoute('/auditonsite/onsitetemplates' && typeof audit.status !== 'undefined')
				"
			>
				<v-col>
					<h2>
						Audit Onsite<v-icon right>fas fa-turn-down</v-icon>
					</h2>
					<p>
						This audit can be duplicated by your suppliers, to be sent to their suppliers.
					</p>
					<p>
						The Audit has 
						<span v-if="audit.retransmissions > 0">
							been re-transmitted, and filled out, <b>{{audit.retransmissions}}</b> times.
							<br>
							The longest flow down chain is <b>{{audit.retransmission_depth}}</b> steps.
						</span>
						<span v-else>not been re-transmitted yet.</span>
						
					</p>
				</v-col>
			</v-row>
			<v-row
				class="contentRow white--text"
				v-bind:class="{
					primary: audit.status == 0,
					success: audit.status == 1,
					warning: audit.status == 2,
					error: audit.status == 3
				}"
				v-if="audit && typeof audit.status !== 'undefined'"
			>
				<v-col>
					<h2>Audit is {{ status(audit.status) }}.</h2>
					<p>{{ audit.statusComment }}</p>
				</v-col>
			</v-row>
			<v-row class="contentRow" v-if="audit">
				<v-col cols="12">
					<h2>Download Audit {{ templateName }} as PDF Document</h2>
				</v-col>
				<v-col cols="12">
					<v-btn
						v-if="audit.status !== undefined"
						color="primary"
						@click="downloadAudit(audit.id)"
						>Download</v-btn
					>
					<v-btn v-else color="primary" @click="downloadAudit(audit.id)"
						>Download</v-btn
					>
				</v-col>
			</v-row>
			
			<!--Temporarily hidden for UX reasons-->
			<v-row class="contentRow secondary" v-if="false">
				<v-col cols="12" class="white--text">
					<h2 class="mb-4">
						Blockchain Status:
						<v-chip
							v-if="audit.BlockchainStatus !== 'Awaiting Validification'"
							color="success"
							label
							dark
							>Validified</v-chip
						>
						<v-chip color="warning" label dark v-else>{{
							audit.BlockchainStatus
						}}</v-chip>
					</h2>
					<p v-if="audit.BlockchainStatus !== 'Awaiting Validification'">
						<i
							>The Audit has been validified by the blockchain. Visit the link
							below to see the block in the blockchain.</i
						>
					</p>
					<p v-else>
						<i
							>The Audit has not yet been validified, and is waiting to be added
							to the blockchain.</i
						>
					</p>
					<v-chip
						v-if="audit.BlockchainStatus !== 'Awaiting Validification'"
						:href="'https://nodes.orixe.tech/blocks/' + audit.BlockchainStatus"
						target="_blank"
						color="blue"
						class="text-decoration-underline"
						label
						dark
						>Go to Block #{{ audit.BlockchainStatus }}
						<v-icon small right>fas fa-external-link-alt</v-icon></v-chip
					>
					<v-chip v-else color="blue" label dark disabled
						>Go to Block<v-icon small right
							>fas fa-external-link-alt</v-icon
						></v-chip
					>
				</v-col>
			</v-row>
			<v-dialog v-model="commentBoxOpen" persistent max-width="600">
				<v-card>
					<v-col>
						<v-card-title>How was your overall experience using the Orixe platform?</v-card-title>
						<v-btn icon :color="platform === 1 ? 'orangeButton' : 'primary'" class="ma-8" @click="platformComment(1)" large><v-icon large>far fa-sad-tear</v-icon></v-btn>
						<v-btn icon :color="platform === 2 ? 'orangeButton' : 'primary'" class="ma-8" @click="platformComment(2)" large><v-icon large>far fa-frown</v-icon></v-btn>
						<v-btn icon :color="platform === 3 ? 'orangeButton' : 'primary'" class="ma-8" @click="platformComment(3)" large><v-icon large>far fa-meh</v-icon></v-btn>
						<v-btn icon :color="platform === 4 ? 'orangeButton' : 'primary'" class="ma-8" @click="platformComment(4)" large><v-icon large>far fa-smile</v-icon></v-btn>
						<v-btn icon :color="platform === 5 ? 'orangeButton' : 'primary'" class="ma-8" @click="platformComment(5)" large><v-icon large>far fa-laugh</v-icon></v-btn>
					</v-col>
					<v-col>
						<v-card-title>How was is to navigate in the platform?</v-card-title>
						<v-btn icon :color="navigation === 1 ? 'orangeButton' : 'primary'" class="ma-8" @click="navigationComment(1)" large><v-icon large>far fa-sad-tear</v-icon></v-btn>
						<v-btn icon :color="navigation === 2 ? 'orangeButton' : 'primary'" class="ma-8" @click="navigationComment(2)" large><v-icon large>far fa-frown</v-icon></v-btn>
						<v-btn icon :color="navigation === 3 ? 'orangeButton' : 'primary'" class="ma-8" @click="navigationComment(3)" large><v-icon large>far fa-meh</v-icon></v-btn>
						<v-btn icon :color="navigation === 4 ? 'orangeButton' : 'primary'" class="ma-8" @click="navigationComment(4)" large><v-icon large>far fa-smile</v-icon></v-btn>
						<v-btn icon :color="navigation === 5 ? 'orangeButton' : 'primary'" class="ma-8" @click="navigationComment(5)" large><v-icon large>far fa-laugh</v-icon></v-btn>
					</v-col>
					<v-col>
						<v-card-title>How was your experience completing the task?</v-card-title>
						<v-btn icon :color="task === 1 ? 'orangeButton' : 'primary'" class="ma-8" @click="taskComment(1)" large><v-icon large>far fa-sad-tear</v-icon></v-btn>
						<v-btn icon :color="task === 2 ? 'orangeButton' : 'primary'" class="ma-8" @click="taskComment(2)" large><v-icon large>far fa-frown</v-icon></v-btn>
						<v-btn icon :color="task === 3 ? 'orangeButton' : 'primary'" class="ma-8" @click="taskComment(3)" large><v-icon large>far fa-meh</v-icon></v-btn>
						<v-btn icon :color="task === 4 ? 'orangeButton' : 'primary'" class="ma-8" @click="taskComment(4)" large><v-icon large>far fa-smile</v-icon></v-btn>
						<v-btn icon :color="task === 5 ? 'orangeButton' : 'primary'" class="ma-8" @click="taskComment(5)" large><v-icon large>far fa-laugh</v-icon></v-btn>
					</v-col>
					<v-col>
						<v-card-title>Do you have any suggestions for improvement?</v-card-title>
						<v-card-text>
							<!-- Your comment box content goes here -->
							<v-textarea v-model="comment"></v-textarea>
						</v-card-text>
					</v-col>
					<v-card-actions>
						<v-btn @click="submitComment()" color="primary">Submit</v-btn>
						<v-btn @click="commentBoxOpen = false" color="primary">Cancel</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</div>
		<v-row v-else-if="feedback == 1" class="contentRow pr-15 pl-15">
			<v-col cols="12" class="pl-15 pr-15">
				<v-card-actions class="justify-end">
					<v-icon class="pl-1 pr-1" color="primary" @click="cancelFeedback()" style="border: 1px solid ;">fas fa-thin fa-times</v-icon>
				</v-card-actions>
				<v-img alt="Success Icon" :src="require('../../assets/twemoji/success.svg')" width="70" class="mx-auto my-8" />
				<h2 class="mb-5">Thank You for Your Feedback!</h2>
				<p>We truly appreciate you taking the time to share your thoughts. Your input helps us make Orixe more effective and user-friendly.</p>
				<p>At Orixe, we believe transparency and accountability are essntial for a better future.</p>
				<p>Supply chains impact the environment, human rights, and resources -- but often lack the visibility needed for responsible management.</p>
				<p>Together we're working towards ethical, sustainable supply chains that build trust and drive progress.</p>
				<p>Thank you for being part of this journey!</p>
			</v-col>
			<v-col cols="12" align="center">
				<v-btn class="ma-2 white--text" color="primary" to="/account">UPGRADE MY ACCOUNT</v-btn>
			</v-col>
		</v-row>
		<v-dialog v-model="exitDialog" max-width="700">
			<v-card cols="12" class="pa-10">
				<v-card-actions class="justify-end">
					<v-icon class="pl-1 pr-1" color="primary" @click="cancelExit()" style="border: 1px solid ;">fas fa-thin fa-times</v-icon>
				</v-card-actions>
				<p>"At Orixe, we believe businesses are the world's most influential institutions. Their decisions shape supply chains, 
					communities, and ecosystems, impacting lives and economies. However, the complexity of global supply chains often makes it 
					challenging to ensure ethical practices and minimize environmental harm.</p>
				<p>We believe this challenge can be addressed by combining advanced technology with core values like integrity, accountability, and fairness, 
					enabling organizations to act decisively and effectively."</p>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
import LoadingState from "../../consts/LoadingState"
import AuditAPI from "../../api/audit/audit"
import RequestAPI from "../../api/audit/request"
import router from "../../router"
import FilesAPI from "../../api/files/files"
import FileUploaderVue from "../../components/FileUploader.vue"
export default {
	name: "OnsiteAuditDetails",
	components: {
		"file-uploader": FileUploaderVue
	},
	data() {
		return {
			id: 69,
			prevId: null,
			auditData: [],
			audit: null,
			templateName: null,
			editRequest: null,
			recipientName: null,
			senderName: null,
			comment: null,
			requestEditComment: null,
			expiryDateMenu: false,
			newExpiryDate: null,
			statusHeaders: [
				{
					text: "Username",
					value: "username",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Status",
					value: "status",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Timestamp",
					value: "timestamp",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Comment",
					value: "comment",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Checklist",
					value: "checklistAnswers",
					sortable: false,
					class: "secondary--text"
				}
			],
			checklist: [],
			checklistAnswers: [],
			replacing: null,
			replacedBy: null,
			logo: null,
			confirmationDialog: false,
			selectedStatusId: null,
			auditStatus: null,
			commentBoxOpen: false,
			navigation: null,
			platform: null,
			task: null,
			isFeedbackGiven: false,
			feedback: 0,
			exitDialog: false,
		}
	},
	mounted() {
		if (isNaN(parseInt(this.$route.params.id))) {
			router.push("/")
		} else {
			this.id = parseInt(this.$route.params.id)
			this.loadAudit()
		}

		this.getFeedbackData()
	},
	methods: {
		getFeedbackData(){
			let currentTime = new Date()
			RequestAPI.getFeedback()
				.then(result => {
					for (let entry of result) {
						if( entry.Module == 2){
							let submittedTime = new Date(entry.SubmitTime)
							let different = Math.floor((currentTime - submittedTime) / (1000 * 60 * 60 * 24))
							if(different < 60){
								this.isFeedbackGiven = true
							}
						}
					}
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		loadAudit() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			AuditAPI.getOnsiteSupplierView(this.id)
				.then(result => {
					this.audit = result
					this.auditData = result.answers
					this.templateName = result.templateName
					this.editRequest = result.editRequest
					this.recipientName = result.recipientName
					this.senderName = result.senderName
					this.comment = result.statusComment
					this.checklist = result.checklist || []
					this.replacing = result.replacing
					this.replacedBy = result.replacedBy
					this.logo = result.logoURL
					this.$set(
						this,
						"checklistAnswers",
						result.statusChecklist
							? result.statusChecklist
							: this.checklist.map(() => false)
					)
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
					this.auditStatus = result.status
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		shouldDisplay(question) {
			if (question.type == "spacer") {
				return true
			}
			if (question.visible == true) {
				return true
			}
			return false
		},
		status(id) {
			if (id == 0) {
				return "Pending"
			} else if (id == 1) {
				return "Approved"
			} else if (id == 2) {
				return "Conditionally Approved"
			} else if (id == 3) {
				return "Denied"
			}
		},
		downloadFile(fileID, name) {
			FilesAPI.download("" + fileID, name)
		},
		checkOff(index) {
			this.checklistAnswers[index] = !this.checklistAnswers[index]
				? true
				: false
		},
		downloadAudit(auditID) {
			let name = "audit_"
			name += this.templateName
			if (this.audit && this.audit.status !== "undefined") {
				name += `_${this.senderName}`
			} else {
				name += `_${this.recipientName}`
			}
			name = name.split(" ").join("_")
			AuditAPI.downloadOnsiteSupplierAuditPDF(auditID, name)
		},
		flowDown() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			AuditAPI.flowDown(this.id)
				.then(val => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"Successfully created template!",
						{ root: true }
					)
					router.push("/audit/templates/" + val)
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		platformComment(selected) {
			this.platform = selected
			this.commentBoxOpen = true
		},
		navigationComment(selected) {
			this.navigation = selected
		},
		taskComment(selected) {
			this.task = selected
		},
		closeCommentBox() {
			this.commentBoxOpen = false
		},
		submitComment() {
			let id = this.$route.params.id
			let submitTime = new Date().toISOString().slice(0, 19).replace("T", " ")
			let module = this.$route.path.split("/")[1]
			
			RequestAPI.submitFeedback(id,submitTime,this.platform,this.navigation,this.task,this.comment,module)
				.then( () => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						`Successfully submit the feedback`,
						{ root: true }
					)
					this.commentBoxOpen = false
				})
				.catch(error => {
					this.error = error
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
			this.commentBoxOpen = false
			this.feedback = 1
		},
		cancelFeedback(){
			this.exitDialog = true
		},
		cancelExit(){
			this.exitDialog = false
			this.$router.push("/")
		},
		getFreeAcc(){
			this.$router.push("/account")
		}
	}
}
</script>

<style scoped>
	.denybutton:not(.outlined){
		color: white;
	}
</style>